import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { findDOMNode } from 'react-dom'
import { FormattedMessage } from 'react-intl'
import Avatar from 'material-ui/Avatar'
import Chip from 'material-ui/Chip'
import images from '../../../config/images'
import {avatarStyles, UserName} from './styles'
import { getImageURI, checkFailedPaymentStatus } from '../../../lib'
import ProfileDropDown from './ProfileDropDown'
import config from '../../../config/config'

class Profile extends Component {
  constructor(props) {
    super(props)

    this.state = {
      popOverOpen: false,
      anchorEl: null,
      open: false,
      listModalOpen: false,
      listModalPurpose: null,
    }
  }

  handleClick = e => {
    e.preventDefault()
    const node = findDOMNode(this)
    this.setState({
      popOverOpen: true,
      anchorEl: node
    })
  }

  handleRequestClose = () => {
    this.setState({
      popOverOpen: false
    })
  }



  render() {
    const textColor = '#000000'
    const imageURI = getImageURI(this.props.userid, images.avatar)
    return (
      <div className="h-100 flex items-center pr3 pointer">
        {this.props.expires_in !== 'never' && <div>
          <div className='pl3 flex justify-around flex-column expire-message' style={{
            position: 'absolute',
            top: '1.2vh',
            left: '18vw',
            height: '4vh'
          }}>
           {!config.IS_MAINTENANCE ? <Chip backgroundColor={'#ffc514'}
                                            labelColor={'white'}>
              <div className='ttu'>
                {this.props.expires_in > 0 ?
                  <div>
                      {this.props.expires_in}
                      <FormattedMessage id="plan.trialEndsIn"/>
                  </div>
                :
                  <div>
                    <FormattedMessage id="plan.expired"/>
                  </div>
                }
              </div>
            </Chip> : '' }
          </div>
        </div>}
        {checkFailedPaymentStatus(this.props) && <div>
          <div className='pl3 flex justify-around flex-column' style={{
            position: 'absolute',
            top: '1.5vh',
            left: '16vw',
            height: '4vh'
          }}>
            {!config.IS_MAINTENANCE ? <Chip backgroundColor={'#ffc514'}
                                            labelColor={'white'}>
              <div className='ttu'>
                <div>
                  {this.props.failed_payment_count >=2 ?
                    <FormattedMessage id="user.secondFailedCreditPayment"/>
                  :
                    <FormattedMessage id="user.firstFailedCreditPayment"/>
                  }
                </div>
              </div>
            </Chip>: '' }
          </div>
        </div>}
        {this.props.view === 'desktop' ? <a href="https://drive.google.com/drive/folders/1IDbugtjQDn3Oet9ffa-0j8rSovFgx5Uk" className="pr3"
           style={{color: 'black', opacity: 0.5, textDecoration: 'none'}}>
          <div style={{padding: '20px', whiteSpace: 'nowrap'}}>
            <FormattedMessage id="loggedInNavigation.manual"/>
          </div>
        </a> : ''}
        {this.props.view !== 'sm-mobile' ? <Link
            className="pr3"
            style={{color: 'black', opacity: 0.5, textDecoration: 'none'}}
            to={'/admin'}
          >
            <div
                onClick={this.props.handleLanguage}
                style={{padding: '20px', whiteSpace: 'nowrap'}}>
              {'日本語/English'}
            </div>
          </Link> : ''}
          {!config.IS_MAINTENANCE ? <div
          className="h-100 flex items-center pr3 pointer"
          onClick={this.handleClick}
        >
          <div className="tr pr3 flex flex-column justify-between">
            <UserName className="username" textColor={textColor}>{this.props.name}</UserName>
          </div>
          <Avatar style={avatarStyles} src={imageURI} size={30}/>
          <ProfileDropDown
            location={this.props.location}
            newSeminarUpgradeModal={this.props.newSeminarUpgradeModal}
            popOverOpen={this.state.popOverOpen}
            anchorEl={this.state.anchorEl}
            anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'right', vertical: 'top'}}
            onRequestClose={this.handleRequestClose}
            userid={this.props.userid}
            email={this.props.email}
            name={this.props.name}
            accountType={this.props.accountType}
            logoutUser={this.props.logoutUser}
            logoutSuccess={this.props.logoutSuccess}
            recieveLoginstatus={this.props.recieveLoginstatus}
            shouldRedirectUser={this.props.shouldRedirectUser}
            upgradeUser={this.props.upgradeUser}
          />
        </div> : ''}
      </div>
    )
  }
}

export default Profile


// WEBPACK FOOTER //
// src/components/Profile/NavBarProfile/Profile.js